import React from "react";
import { __ } from "services/Translator";
import { useIsAuthenticated } from "components/auth/AuthGate";
import { TeaserHero } from "components/auth/teaser";

/**
 * VipConversion — the call-to-action block that closes the VIP pitch.
 *
 * Logged-out visitor (a stranger): a real "Become a Clover Climber" sign-up
 * panel with the working Sign-Up / Log-in pair. NO personal data, no balances,
 * no "your tier" — purely a conversion surface.
 *
 * Logged-in player: the same panel re-purposed to "keep climbing", with a
 * working "Deposit now" button (opens the real cashier) instead of Sign-Up.
 *
 * `variant`: "mid" (after the tier ladder) | "closer" (after the FAQ).
 */
export default function VipConversion(props) {
  const { variant = "mid" } = props;
  const isAuthed = useIsAuthenticated();

  if (isAuthed) {
    return (
      <TeaserHero
        className="vip-conversion vip-conversion--authed"
        align="center"
        eyebrow={__("Your VIP journey")}
        title={
          variant === "closer"
            ? __("Keep climbing your Clover tiers")
            : __("Every bet earns your next tier")
        }
        subtitle={__(
          "Top up and keep playing — each real-money wager earns Clover Points toward richer cashback, VIP tournaments and a dedicated host."
        )}
        signUpLabel={__("Deposit now")}
        showLogin={false}
        onSignUp={() =>
          typeof props.setOpenWalletModalTab === "function" &&
          props.setOpenWalletModalTab("deposit")
        }
      />
    );
  }

  return (
    <TeaserHero
      className={
        "vip-conversion" + (variant === "closer" ? " vip-conversion--closer" : "")
      }
      align="center"
      eyebrow={__("Join the Clover Climber VIP Club")}
      title={
        variant === "closer"
          ? __("Ready to start climbing?")
          : __("Become a Clover Climber")
      }
      subtitle={__(
        "Create your account in seconds. Your first Clover Points are a single spin away — start earning cashback, tournaments and VIP perks today."
      )}
      signUpLabel={__("Join now")}
      setModalSignUpPropsData={props.setModalSignUpPropsData}
      setModalLoginPropsData={props.setModalLoginPropsData}
    >
      <p className="vip-teaser__legal">
        {__(
          "18+ only. Play responsibly. Terms & conditions apply. Available where permitted by law."
        )}
      </p>
    </TeaserHero>
  );
}
